import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  platesActive: [],
  thicknesId: "",
  laserType: "",
  colorSized:[]
};

const UpdatePlatesActive = (state, action) => {
  state.platesActive = action.payload;
};
const updateThicknesId = (state, action) => {
  state.thicknesId = action.payload;
};
const setLaserType = (state, action) => {
  state.laserType = action.payload;
};
const setColorSized=(state,action)=>{
  state.colorSized=action.payload
}
const reserLaserStore = (state) => {
  state.platesActive = []; 
  state.thicknesId = ""; 
  state.laserType = "";
};
const LaserSlice = createSlice({
  name: "laser",
  initialState,
  reducers: {
    UpdatePlatesActive,
    updateThicknesId,
    setLaserType,
    reserLaserStore,
    setColorSized
  },
});

export const {
  UpdatePlatesActive: UpdatePlatesActiveR,
  updateThicknesId: updateThicknesIdR,
  setLaserType: setLaserTypeR,
  reserLaserStore:reserLaserStoreR,
  setColorSized:setColorSizedR
} = LaserSlice.actions;

export default LaserSlice.reducer;
